import { render, staticRenderFns } from "./ButtonCheckbox.vue?vue&type=template&id=03d87445&"
import script from "./ButtonCheckbox.vue?vue&type=script&lang=js&"
export * from "./ButtonCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports